import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './assets/main.css'
import logger from '@/utils/logger'

// Easter egg: F12 console signature
console.log(
  '%c⚡ VIGILANCE HQ ⚡%c\n%cAuthorized Personnel Only\nVigil Cyber LLC — Securing the Digital Frontier\nhq.vigilcyber.com',
  'color: #10b981; font-size: 24px; font-weight: bold; text-shadow: 0 0 10px #10b981;',
  '',
  'color: #94a3b8; font-size: 12px;'
);

const app = createApp(App)
app.use(createPinia())
app.use(router)

// Global error handler to catch Vue errors
app.config.errorHandler = (err, instance, info) => {
  logger.error('[Vue Error]', err, { component: instance?.$options?.name || 'Unknown', info })

  // Auto-reload on chunk load failures (happens after deployments)
  if (err instanceof Error && err.message.includes('Failed to fetch dynamically imported module')) {
    logger.warn('[Auto-Reload] Chunk load failed, reloading page...')
    window.location.reload()
  }
}

// Click outside directive
app.directive('click-outside', {
  mounted(el, binding) {
    el._clickOutside = (event: MouseEvent) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value(event)
      }
    }
    document.addEventListener('click', el._clickOutside)
  },
  unmounted(el) {
    document.removeEventListener('click', el._clickOutside)
  }
})

app.mount('#app')
